export const bootstrapApp = async () => Promise.resolve();
export default bootstrapApp;
//# sourceMappingURL=bootstrapApp.js.map